import React from 'react';
import styled from 'styled-components';
import Icon from '@ant-design/icons';
import { colors } from 'helpers/ColorHelper';

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  font-size: 14px;
  color: ${(props) => props.color};
`;

const StyledButton = styled.button`
  color: ${(props) => (props.filled ? '#fff' : 'var(--dark)')};
  background-color: ${(props) => (props.filled ? props.accentColor : '#fff')};
  font-size: 12px;
  font-weight: bold;
  border: solid 1px ${(props) => props.accentColor};
  border-radius: 25px !important;
  padding-right: ${(props) => (props.onlyIcon ? '5px' : '18px')};
  padding-left: ${(props) => (props.icon ? '33px' : '20px')};
  height: 40px;
  line-height: 40px;
  text-align: center;
  position: relative;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    background-color: ${(props) => (props.filled ? props.accentColor : '#bdd9ff')};
  }
`;

const CtaSecondary = ({
  accentColor = colors.ULTRAMARINE_BLUE,
  icon,
  onlyIcon,
  children,
  filled,
  ...rest
}) => {
  return (
    <StyledButton
      filled={filled}
      onlyIcon={onlyIcon}
      accentColor={accentColor}
      icon={icon}
      {...rest}
    >
      {icon ? <StyledIcon component={icon} color={filled ? '#fff' : accentColor} /> : null}
      {onlyIcon ? null : children}
    </StyledButton>
  );
};

export default CtaSecondary;
